
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.422 8.898c.26.235.56.352.898.352.339 0 .625-.117.86-.352.26-.234.39-.533.39-.898s-.13-.664-.39-.898a1.169 1.169 0 00-.86-.352c-.338 0-.638.117-.898.352-.235.234-.352.533-.352.898s.117.664.352.898zM8 11.32V4.68h8.32v6.64H8zM15.5 13v.82c0 .443-.17.834-.508 1.172-.338.339-.729.508-1.172.508H2.18c-.47 0-.873-.156-1.211-.469a1.724 1.724 0 01-.469-1.21V2.18c0-.47.156-.86.469-1.172A1.653 1.653 0 012.179.5H13.82c.443 0 .834.17 1.172.508.339.338.508.729.508 1.172V3H8c-.469 0-.872.17-1.21.508-.313.312-.47.703-.47 1.172v6.64c0 .47.157.873.47 1.211.338.313.741.469 1.21.469h7.5z","fill":"currentColor"}})])
          )
        }
      }
    